const firebaseConfig = {
    apiKey: "AIzaSyDvetSJEr2Fz6xx4SoseRzkul9ljf5Jjts",
    authDomain: "simple-assignment-auth-997f4.firebaseapp.com",
    projectId: "simple-assignment-auth-997f4",
    storageBucket: "simple-assignment-auth-997f4.appspot.com",
    messagingSenderId: "753114757394",
    appId: "1:753114757394:web:8764974562d318a70d1bcb"
};

export default firebaseConfig;